module.exports = __webpack_public_path__ + "static/media/389094_2_0.af7c2150.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/helpers/webfonts/389094_2_0.woff2
// module id = 725
// module chunks = 0